<template>
  <b-card style="border: 1px solid #0000001a">
    <b-col cols="12" class="d-flex justify-content-between align-items-center">
      <h5 class="font-weight-bolder">Compliance Requirements</h5>
      <b-button variant="primary" size="sm" class="font-weight-bolder">
        <feather-icon icon="PlusIcon" />
        Add Compliance
      </b-button>
    </b-col>

    <b-col cols="12" class="mt-1">
      <b-table
        :items="requirements"
        :fields="fields"
        responsive
        thead-class="text-nowrap"
      >
        <template #cell(requirement)="data">
          <span class="font-weight-bolder">{{ data.item.requirement }}</span>
        </template>

        <template #cell(status)="data">
          <b-badge :variant="getStatusVariant(data.item.status)" pill>
            {{ data.item.status }}
          </b-badge>
        </template>

        <template #cell(recurring)="data">
          <b-badge :variant="data.item.recurring ? 'success' : 'secondary'" pill>
            {{ data.item.recurring ? "YES" : "NO" }}
          </b-badge>
        </template>

        <!-- Actions column -->
        <template #cell(actions)="data">
          <div class="d-flex align-items-center" style="gap: 4px">
            <v-select
              v-model="data.item.status"
              :options="statusOptions"
              :clearable="false"
              :reduce="(val) => val"
              style="min-width: 240px; font-size: 12px"
              class="mr-1"
            />
            <b-button size="sm" variant="link" class="p-0 text-primary mr-1">
              <feather-icon icon="EyeIcon" />
            </b-button>
            <b-button size="sm" variant="link" class="p-0 text-danger">
              <feather-icon icon="TrashIcon" />
            </b-button>
          </div>
        </template>
      </b-table>
    </b-col>
  </b-card>
</template>

<script>
import { BCard, BButton, BTable, BBadge, BRow, BCol } from "bootstrap-vue";
import vSelect from "vue-select";
export default {
  components: {
    BCard,
    BButton,
    BTable,
    BBadge,
    BRow,
    BCol,
    vSelect,
  },
  data() {
    return {
      statusOptions: [
        "Completed",
        "Renewed",
        "Pending",
        "Upcoming (within 3 months)",
        "Expired",
      ],
      fields: [
        { key: "requirement", label: "Requirement" },
        { key: "description", label: "Description" },
        { key: "status", label: "Status" },
        { key: "renewalDate", label: "Renewal Date" },
        { key: "recurring", label: "Recurring" },
        { key: "owner", label: "Owner" },
        { key: "lastCheck", label: "Last Check" },
        { key: "nextCheck", label: "Next Check" },
        { key: "actions", label: "Actions" },
      ],
      requirements: [
        {
          requirement: "AUSTRAC AML/CTF Compliance",
          description: "Anti-Money Laundering and Counter-Terrorism Financing requirements",
          status: "Renewed",
          renewalDate: "2025-01-14",
          recurring: true,
          owner: "Compliance Team",
          lastCheck: "2025-01-07",
          nextCheck: "2025-01-14",
        },
        {
          requirement: "ACMA Interactive Gambling Compliance",
          description: "Australian Communications and Media Authority gambling regulations",
          status: "Completed",
          renewalDate: "2025-06-01",
          recurring: true,
          owner: "Legal Team",
          lastCheck: "2025-01-06",
          nextCheck: "2025-01-20",
        },
        {
          requirement: "Privacy Act 1988 Compliance",
          description: "Australian privacy law compliance for personal information",
          status: "Upcoming (within 3 months)",
          renewalDate: "2025-03-15",
          recurring: true,
          owner: "Privacy Officer",
          lastCheck: "2025-01-05",
          nextCheck: "2025-01-12",
        },
        {
          requirement: "PCI DSS Level 1",
          description: "Payment Card Industry Data Security Standard compliance",
          status: "Pending",
          renewalDate: "2025-04-10",
          recurring: false,
          owner: "Security Team",
          lastCheck: "2024-12-20",
          nextCheck: "2025-01-10",
        },
        {
          requirement: "ISO 27001 Information Security",
          description: "International standard for information security management",
          status: "Completed",
          renewalDate: "2026-01-01",
          recurring: true,
          owner: "IT Security",
          lastCheck: "2025-01-01",
          nextCheck: "2025-01-15",
        },
        {
          requirement: "Consumer Data Right (CDR)",
          description: "Australian Consumer Data Right implementation requirements",
          status: "Expired",
          renewalDate: "2024-12-31",
          recurring: false,
          owner: "Data Team",
          lastCheck: "2024-12-25",
          nextCheck: "2025-01-08",
        },
      ],
    };
  },
  methods: {
    getStatusVariant(status) {
      switch (status) {
        case "Completed":
          return "success";
        case "Renewed":
          return "primary";
        case "Pending":
          return "warning";
        case "Upcoming (within 3 months)":
          return "info";
        case "Expired":
          return "danger";
        default:
          return "secondary";
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
